import { render, staticRenderFns } from "./Ptg.vue?vue&type=template&id=bc7999c2&scoped=true&"
import script from "./Ptg.vue?vue&type=script&lang=js&"
export * from "./Ptg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7999c2",
  null
  
)

export default component.exports